export const ITEM_SEPARATOR = '||';
export const FIELD_SEPARATOR = '&';
export const PARAMETER_SEPARATOR = '_';
export const TIMESTAMP_FIELD_KEY = '_cl';
export const CID_COOKIE_KEY = 'AUTOHERO';
export const CID_QUEUE_LIMIT = 15;
export const COOKIE_TIME_LIMIT_IN_SECONDS = 3600; // 1 hour
export const COOKIE_EXPIRY_IN_DAYS = 730; // 2 Years
export const MID_QUERY_KEY = 'MID';
export const EXPID_QUERY_KEY = 'utm_expid';
export const EXPID_FIELD_KEY = 'expid';
export const APP_REDIRECT_QUERY_KEY = 'ah_src';
export const D_PLATFORM_FIELD_KEY = '_dplatform';
